var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"function-card-container"},[(_vm.active==='upload')?_c('Upload'):(_vm.active==='handle')?_c('Handle'):(_vm.active==='project')?_c('Project'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }